import PriceBreakdown from '../models/priceBreakdown';

var PriceBreakdownList = Backbone.Collection.extend( {

    model: PriceBreakdown,

    initialize: function () {
        this.listenTo( this, 'select:one', this.selectOne );
        this.listenTo( this, 'update:qty', this.updatePriceBreakdown );
    },

    selectOne: function ( item ) {
        this.unselectAll();
        this.find( item ).set( 'selected', true );
    },

    unselectAll: function () {
        var selected = this.where( {selected: true} );
        _.each( selected, function ( item ) {
            return item.set( 'selected', false );
        } );
    },

    updatePriceBreakdown: function ( qty ) {
        var qualifiedPriceBreak = this.getQualifiedPriceBreak( qty );
        if ( -Infinity !== qualifiedPriceBreak ) {
            this.selectOne( qualifiedPriceBreak );
        }
        else {
            this.unselectAll();
        }
    },

    getQualifiedPriceBreak: function ( qty ) {
        // filter breaks where qty is greater than priceBreak.quantity
        var breakpoints = this.filter( function ( item ) {
            return qty >= parseInt( item.get( 'quantity' ), 10 );
        } );

        // then return max based on priceBreak.quantity on list
        let bp = _.maxBy( breakpoints, function ( item ) {
            return parseInt( item.get( 'quantity' ), 10 );
        } );

        return bp;
    }

} );

export default PriceBreakdownList;
